import { render, staticRenderFns } from "./RegistrationMainPage.vue?vue&type=template&id=55c89df6&scoped=true&"
import script from "./RegistrationMainPage.vue?vue&type=script&lang=js&"
export * from "./RegistrationMainPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c89df6",
  null
  
)

export default component.exports